import { Stiuacao } from 'src/app/service/classes/cadastro/stiuacao';
import { Supervisor } from 'src/app/service/interfaces/Supervisor';
import { Matricula } from './../../contracheque/contracheque.component';
import { ObservacoesFichaFuncionalService } from './observacoes-ficha-funcional.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import Swal from 'sweetalert';
import { Permissao } from 'src/app/service/permissoes/permissoes.service';

@Component({
  selector: 'app-observacoes-ficha-funcional',
  templateUrl: './observacoes-ficha-funcional.component.html',
  styleUrls: ['./observacoes-ficha-funcional.component.css'],
})
export class ObservacoesFichaFuncionalComponent {
  @Output() gatilhoAtivado = new EventEmitter<any>();
  @Input() colaborador: any;
  @Input() tipo: string;
  @Input() permissoes: Permissao[];
  podeEditar = true;
  localStorage: LocalStorage;
  compchave: string = '';
  cadastro: boolean = true;
  formObservacoes: FormGroup;
  listaObservacoesAuxiliar = [];
  listaObservacoes: any = [];
  filialAtual: string = '';
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private observacoesService: ObservacoesFichaFuncionalService
  ) {
    this.localStorage = this.decryptLocalStorage();

    this.filialAtual = String(this.localStorage.FilialAtual);
  }

  ngOnInit() {
    this.formObservacoes = this.fb.group({
      observacao: ['', Validators.required],
      data: ['', Validators.required],
    });
  }

  abrirModal(data?: any, tipo?: string) {
    if (data && tipo) {
      this.tipo = tipo;
    }
    this.limparForm();

    switch (this.tipo) {
      case '703':
        // Tempo de Serviço
        this.compchave = data.DtIni.SetData + data.DtFim.SetData;
        break;
      case '007':
        // Faltas ao Trabalho
        this.compchave =
          data.DtInicio.SetData + data.DtVolta.SetData + data.CodAfa + data.CodMot + data.Seq;
        break;
      case '010':
        // Promoções
        this.compchave = data.DtComp + data.TpProc + data.Seq;
        break;
      case '104':
        // Programação de Férias
        this.compchave =
          data.EmpresaFilial.toString() +
          data.Matricula.toString() +
          data.TipoProcessamento.toString() +
          data.PeriodoAquisitivo?.DataInicio?.SetData;
        break;
      case '013':
        // Prontuário Médico
        this.compchave = data.DtInsp.SetData;
        break;
      case '009':
        // Formação Básica e Específica
        this.compchave = data.DtTermino.SetData + data.CodCrs;
        break;
      case '018':
        // Licença Prêmio
        this.compchave = data.Seq;
        break;
      case '110':
        // Comissão
        this.compchave = data.Seq;
        break;
      case '207':
        // Experiência Profissional
        this.compchave = '';
        break;
      case '208':
        // Lançamento Financeiro
        this.compchave = data.CodigoVerba.padStart(3, '0') + data.Transacao.padStart(2, '0');
        break;
      case '209':
        // Lotações Vinculadas
        this.compchave = data.Codigo;
        break;
      case '012':
        // Pensão Alimentícia
        this.compchave = data.CodigoPensao;
        break;
      case '014':
        // Complemento Cadastral /Estágio

        this.compchave =
          data.estagiario.NumeroOrdem.padStart(7, '0') +
          data.contrato.NumeroProcesso +
          data.contrato.DataInicial.SetData +
          data.contrato.DataFinal.SetData;
        break;
      case '049':
        // Complemento Cadastral / Cessão
        this.compchave =
          data.cessao.NumeroOrdem.padStart(7, '0') +
          data.contrato.NumeroProcesso +
          data.contrato.DataInicial.SetData +
          data.contrato.DataFinal.SetData;
        //numord+numeroProcesso+VirInicial+Virgfinal
        break;
      case '016':
        // Processos
        //Deferido == Situacao 3
        if (
          data.Situacao != 3 ||
          (data.Situacao == 3 && this.permissoes.find((p) => p.Descricao === 'Deferido'))
        ) {
          this.podeEditar = true;
        } else {
          this.podeEditar = false;
        }
        this.compchave = data.NumeroProcesso + data.DataRet.SetData + data.HoraRet;
        break;
      case '300':
        // Situação Funcional
        // compchave  dtinicio
        this.compchave = '';
        break;
      default:
        Swal('Erro', 'Tipo de página/observação não encontrado', 'error').then(() => {
          document.getElementById('btnCancelarObservacoesModal').click();
        });
        return;
    }
    this.buscarObservacoes();
    console.log(data);
  }

  buscarObservacoes() {
    this.spinner.show('buscarObs');
    this.observacoesService
      .buscarObservacoes(this.filialAtual, this.colaborador.Matricula, this.tipo, this.compchave)
      .subscribe(
        (data: any) => {
          if (data) {
            let listaObs = data.sort((a, b) => a.Seq - b.Seq);
            this.unirObservacoes(listaObs);
          } else {
            this.listaObservacoes = [];
          }
          this.spinner.hide('buscarObs');
        },
        (err) => {
          console.error(err);
          this.spinner.hide('buscarObs');
        }
      );
  }

  formatarDataBarra(data: string): string {
    let ano = data.slice(0, 4);
    let mes = data.slice(4, 6);
    let dia = data.slice(6, 8);

    return dia + '/' + mes + '/' + ano;
  }

  unirObservacoes(dadosBase: any[]) {
    this.listaObservacoesAuxiliar = [];
    this.listaObservacoes = [];
    dadosBase.forEach((item) => {
      let dtcseq = item.DTCSeq;
      let obs = item.Obs;

      if (!this.listaObservacoesAuxiliar[dtcseq]) {
        this.listaObservacoesAuxiliar[dtcseq] = [];
      }

      this.listaObservacoesAuxiliar[dtcseq].push(obs.trim());
    });
    this.listaObservacoes = Object.keys(this.listaObservacoesAuxiliar).map((dtcseq) => {
      return { obs: this.listaObservacoesAuxiliar[dtcseq].join('\n'), dtcseq: dtcseq };
    });
  }

  montarObservacao() {
    if (!this.colaborador) {
      console.error('Erro: colaborador está null ao tentar montar observação');
      return null; // Ou retorne um objeto vazio se necessário
    }

    let dataAtual = new Date();
    let ano = dataAtual.getFullYear().toString();
    let mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0'); // Ajuste para mês correto
    let dia = dataAtual.getDate().toString().padStart(2, '0'); // Correção para getDate()
    let hora = dataAtual.getHours().toString().padStart(2, '0');
    let minuto = dataAtual.getMinutes().toString().padStart(2, '0');

    let observacaoMontada: ObservacaoEnvio = {
      Sigla: 'FAPP',
      Empfil: parseInt(this.filialAtual),
      Mat: parseInt(this.colaborador.Matricula), // Agora com segurança
      Tipo: this.tipo,
      CompChave: this.compchave,
      DTCSeq: this.formObservacoes.get('data').value.replace(/-/g, ''),
      Obs: this.formObservacoes.get('observacao').value.toUpperCase(),
      DataRet: ano + mes + dia,
      HoraRet: hora + minuto,
      CodCad: '',
    };

    return observacaoMontada;
  }

  limparForm() {
    this.formObservacoes.reset();
    this.formObservacoes.get('data').enable();
    this.cadastro = true;
  }
  formatarDataHifen(data: string): string {
    let ano = data.slice(0, 4);
    let mes = data.slice(4, 6);
    let dia = data.slice(6, 8);

    return `${ano}-${mes}-${dia}`;
  }

  editarObservacao(obs: { obs: string; dtcseq: string }) {
    this.formObservacoes.get('observacao').setValue(obs.obs.trim());
    this.formObservacoes.get('data').setValue(this.formatarDataHifen(obs.dtcseq));
    this.formObservacoes.get('data').disable();
    this.formObservacoes.updateValueAndValidity();
    this.cadastro = false;
  }

  cadastrarOuAtualizarObservacao() {
    if (this.formObservacoes.valid) {
      if (this.cadastro) {
        this.spinner.show('createOrUpdate');
        this.observacoesService.inserirObservacao(this.montarObservacao()).subscribe(
          (data) => {
            this.buscarObservacoes();
            this.limparForm();
            this.gatilhoAtivado.emit();
            this.spinner.hide('createOrUpdate');
          },
          (err) => {
            console.error(err);
            this.spinner.hide('createOrUpdate');
          }
        );
      } else {
        this.spinner.show('createOrUpdate');
        this.observacoesService.atualizarObservacao(this.montarObservacao()).subscribe(
          (data) => {
            this.buscarObservacoes();
            this.limparForm();
            this.spinner.hide('createOrUpdate');
          },
          (err) => {
            console.error(err);
            this.spinner.hide('createOrUpdate');
          }
        );
      }
      this.cadastro = true;
    } else {
      this.formObservacoes.get('observacao').markAsTouched();
      this.formObservacoes.get('data').markAllAsTouched();
    }
  }

  deletarObservacao(obs: any) {
    Swal({
      title: 'Deseja realmente excluir essa observação?',
      text: 'Essa ação não pode ser desfeita.',
      icon: 'warning',
      buttons: ['Cancelar', 'Confirmar'],
    }).then((result) => {
      if (result) {
        this.spinner.show('deleteObservacao');
        this.observacoesService
          .deletarObservacao(
            this.filialAtual,
            this.colaborador.Matricula,
            this.tipo,
            obs.dtcseq,
            this.compchave
          )
          .subscribe(
            () => {
              this.buscarObservacoes();
              this.limparForm();
              this.gatilhoAtivado.emit();
              this.spinner.hide('deleteObservacao');
            },
            (err) => {
              console.error(err);
            }
          );
      }
    });
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
  }
}

export interface ObservacaoEnvio {
  Sigla: string;
  Empfil: number;
  Mat: number;
  Tipo: string;
  CompChave?: string;
  DTCSeq: string;
  Obs?: string;
  DataRet?: string;
  HoraRet?: string;
  CodCad: string;
}
